var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:3537,
      name:"计划明细",
      parentId:"PLAN_ID",
      parentName:"数据迁移计划",
      parentPath:"/system/trans/outerPlan",
      dataClass:2,
      implementRowClick: _vm.implementRowClick,
      parentQuery:{
      },
      addForm:{
      },
      col:[],
      sjqyRowClick: _vm.sjqyRowClick
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }